import { AutoAwesomeOutlined } from '@mui/icons-material';
import {
  Archive,
  ArchiveRestore,
  Blocks,
  Building2,
  Calendar,
  CircleCheckBig,
  FileSearch2,
  FileText,
  Goal,
  Handshake,
  ListPlus,
  ListTodo,
  LogOut,
  Mails,
  MessagesSquare,
  Mic,
  Network,
  PanelLeftClose,
  PanelLeftOpen,
  Pencil,
  Pin,
  Settings,
  Settings2,
  Unplug,
  User,
  UserRoundSearch,
  Users,
  Wrench,
} from 'lucide-react';

/**
 * Mapping of icon names to their Lucide React component and Material UI icon paths.
 */
export const iconsMap = {
  deals: {
    lucide: Handshake,
    material: '/dh-icons/mui/deals.svg',
    material2: '/dh-icons/mui/300/deals-300.svg',
  },
  meetingPrep: {
    lucide: ListTodo,
    material: '/dh-icons/mui/action-plan.svg',
    material2: '/dh-icons/mui/300/action-plan-300.svg',
  },
  actionPlan: {
    lucide: CircleCheckBig,
    material: '/dh-icons/mui/action-plan.svg',
    material2: '/dh-icons/mui/300/action-plan-300.svg',
  },
  unlinkedItems: {
    lucide: Unplug,
    material: '/dh-icons/mui/unassociated-items.svg',
    material2: '/dh-icons/mui/300/unassociated-items-300.svg',
  },
  mRecord: {
    lucide: Mic,
    material: '/dh-icons/mui/m-record.svg',
    material2: '/dh-icons/mui/300/m-record-300.svg',
  },
  tools: {
    lucide: Wrench,
    material: '/dh-icons/mui/tools.svg',
    material2: '/dh-icons/mui/300/tools-300.svg',
  },
  myOrg: {
    lucide: Building2,
    material: '/dh-icons/mui/my-org.svg',
    material2: '/dh-icons/mui/300/my-org-300.svg',
  },
  allMembers: {
    lucide: Users,
    material: '/dh-icons/mui/all-members.svg',
    material2: '/dh-icons/mui/300/all-members-300.svg',
  },
  salesOrg: {
    lucide: Network,
    material: '/dh-icons/mui/sales-org.svg',
    material2: '/dh-icons/mui/300/sales-org-300.svg',
  },
  orgData: {
    lucide: FileText,
    material: '/dh-icons/mui/org-data.svg',
    material2: '/dh-icons/mui/300/org-data-300.svg',
  },
  setup: {
    lucide: Settings,
    material: '/dh-icons/mui/setup.svg',
    material2: '/dh-icons/mui/300/setup-300.svg',
  },
  integrations: {
    lucide: Blocks,
    material: '/dh-icons/mui/integrations.svg',
    material2: '/dh-icons/mui/300/integrations-300.svg',
  },
  preferences: {
    lucide: Settings2,
    material: '/dh-icons/mui/preferences.svg',
    material2: '/dh-icons/mui/300/preferences-300.svg',
  },
  profile: {
    lucide: User,
    material: '/dh-icons/mui/profile.svg',
    material2: '/dh-icons/mui/300/profile-300.svg',
  },
  pinned: {
    lucide: Pin,
    material: '/dh-icons/mui/pinned.svg',
    material2: '/dh-icons/mui/300/pinned-300.svg',
  },
  unpinned: {
    lucide: Pin,
    material: '/dh-icons/mui/unpinned.svg',
    material2: '/dh-icons/mui/300/unpinned-300.svg',
  },
  addActivity: {
    lucide: ListPlus,
    material: '/dh-icons/mui/add-activity.svg',
    material2: '/dh-icons/mui/300/add-activity-300.svg',
  },
  updateDeal: {
    lucide: Pencil,
    material: '/dh-icons/mui/update-deal.svg',
    material2: '/dh-icons/mui/300/update-deal-300.svg',
  },
  archive: {
    lucide: Archive,
    material: '/dh-icons/mui/archive.svg',
    material2: '/dh-icons/mui/300/archive-300.svg',
  },
  unarchive: {
    lucide: ArchiveRestore,
    material: '/dh-icons/mui/unarchive.svg',
    material2: '/dh-icons/mui/300/unarchive-300.svg',
  },
  logout: {
    lucide: LogOut,
    material: '/dh-icons/mui/logout.svg',
    material2: '/dh-icons/mui/300/logout-300.svg',
  },
  toggleSidebarExpand: {
    lucide: PanelLeftOpen,
    material: '/dh-icons/mui/toggle-sidebar-expand.svg',
    material2: '/dh-icons/mui/300/toggle-sidebar-expand-300.svg',
  },
  toggleSidebarCollapse: {
    lucide: PanelLeftClose,
    material: '/dh-icons/mui/toggle-sidebar-collapse.svg',
    material2: '/dh-icons/mui/300/toggle-sidebar-collapse-300.svg',
  },
  meetingAgenda: {
    lucide: Calendar,
    material: '/dh-icons/mui/meeting-agenda.svg',
    material2: '/dh-icons/mui/300/meeting-agenda-300.svg',
  },
  meetingGoals: {
    lucide: Goal,
    material: '/dh-icons/mui/meeting-agenda.svg',
    material2: '/dh-icons/mui/300/meeting-agenda-300.svg',
  },
  companyResearch: {
    lucide: FileSearch2,
    material: '/dh-icons/mui/meeting-agenda.svg',
    material2: '/dh-icons/mui/300/meeting-agenda-300.svg',
  },
  stakeholderResearch: {
    lucide: UserRoundSearch,
    material: '/dh-icons/mui/meeting-agenda.svg',
    material2: '/dh-icons/mui/300/meeting-agenda-300.svg',
  },
  mailbox: {
    lucide: Mails,
    material: '/dh-icons/mui/meeting-agenda.svg',
    material2: '/dh-icons/mui/300/meeting-agenda-300.svg',
  },
  askAI: {
    lucide: AutoAwesomeOutlined,
    material: '/dh-icons/mui/meeting-agenda.svg',
    material2: '/dh-icons/mui/300/meeting-agenda-300.svg',
  },
  chats: {
    lucide: MessagesSquare,
    material: '/dh-icons/mui/meeting-agenda.svg',
    material2: '/dh-icons/mui/300/meeting-agenda-300.svg',
  },
};
